<script>
import ModelChildIndex from "../../models/children/index";

export default {
  extends: ModelChildIndex,
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("balancings.plural"));
      }
    },
    resourceRoute: { default: "balancings" },
    modelVariable: { default: "balancing" },
    tableMinHeight: { type: Number, default: 85.5 }, // 42.5 + 43
    tableHeight: { type: Number, default: 214.5 }, // 42.5 + (43 * 4)
    denyCreate: { type: Boolean, default: true },
    hideTableHeader: { type: Boolean, default: true },
    values: {
      type: Array,
      default() {
        return [];
      }
    },
    showProps: {
      default() {
        return {
          cardTitle: this.lodash.startCase(this.$t("balancings.singular")),
          resourceRoute: { default: "balancings" },
          modelVariable: "balancing",
          modelMapped: require("@/router/views/balancings/show.vue").default.computed.modelMapped.bind(this),
          denyEdit: true,
          denyDelete: true
        };
      }
    }
  },
  data() {
    return {
      sortBy: "ordered_at",
      sortDesc: true
    };
  },
  computed: {
    columns() {
      return {
        ["balancing"]: [
          {
            key: "id",
            label: this.lodash.startCase(this.$t("tickets.balancing_id")),
            thStyle: { minWidth: "100px" },
            tdClass: "align-middle",
            component: {
              props: ["item"],
              template:
                '<router-link :to="`/balancings?id_in=${item.id}&balancing_show__id=${item.id}`">{{ item.id }}</router-link>'
            }
          },
          {
            key: "sale_order.id",
            label: this.lodash.startCase(this.$t("tickets.sale_note_id")),
            thStyle: { minWidth: "120px" },
            tdClass: "align-middle",
            component: {
              props: ["item"],
              template: '<router-link :to="`/unloads/${item.sale_order.id}`">{{ item.sale_order.id }}</router-link>'
            }
          },
          // {
          //   key: 'invoice_number',
          //   label: this.lodash.startCase(this.$t('balancing_payments.purchase_invoice')),
          //   thStyle: {minWidth: '140px'},
          //   tdClass: 'align-middle',
          //   component: {
          //     props: ['item'],
          //     computed:{
          //       hasKmtbService(){
          //         return this.item?.sale_order?.trip?.is_km_service;
          //       },
          //       payments(){
          //         if(this.hasKmtbService) {
          //           return this.item?.balancing_payments?.filter((payment, index, self) => self.findIndex((p) => p.invoice_number === payment.invoice_number) === index)
          //         }
          //         const payments = this.item.sale_order.sale_items
          //             .map(item => (
          //                 item.purchase_item.purchase_order.paymentables?.[item.purchase_item.purchase_order.paymentables.length -1].payment || 0
          //             )).flat().filter((payment) => !!payment.id)
          //             .filter((payment, index, self) => self.findIndex((p) => p.id === payment.id) === index)
          //         return payments;
          //       }
          //     },
          //     template: `
          //       <div class="">
          //         <template v-for="(payment, index) in payments">
          //           <component :is="hasKmtbService ? 'div' : 'router-link'" :key="index" :to="'/purchase_payments/'+payment.id">
          //             <div class="d-flex">{{payment.invoice_number}} <span v-if="payments.length > 1 && index !== payments.length - 1">,</span></div>
          //           </component>
          //         </template>
          //       </div>
          //     `
          //   }
          // },
          {
            key: "sale_order.trip.invoice_number",
            label: this.lodash.startCase("purchase invoice"),
            tdClass: "align-middle",
            sortable: false,
            thStyle: { minWidth: "140px" },
            component: {
              props: ["item"],
              template:
                '<router-link :to="`/trips/${item.sale_order.trip.id}`">{{ item.sale_order.trip.invoice_number }}</router-link>'
            }
          },
          {
            key: "customer",
            label: this.lodash.startCase(this.$t("balancings.partner")),
            tdClass: "align-middle",
            sortable: false,
            thStyle: { minWidth: "140px" },
            component: {
              props: ["item"],
              template: '<div :to="`/customers/${item.customer.id}`">{{ item.customer.name }}</div>'
            }
          },
          {
            key: this.lodash.startCase(this.$t("balancings.receiver_name")),
            label: this.lodash.startCase(this.$t("balancings.receiver_name")),
            tdClass: "align-middle",
            thStyle: { minWidth: "140px" },
            sortable: false,
            component: {
              props: ["item"],
              template: `
              <div>
                <div v-if="item.balancing_payments.length > 0" :to="'/customers/'+item.balancing_payments[0].to_bank_account.id">{{ item.balancing_payments[0].to_bank_account.name }}</div>
                <div v-else >-</div>
              </div>
              `
            }
          },
          {
            key: "total_debt",
            label: this.lodash.startCase("nominal balancing"),
            thStyle: { minWidth: "120px" },
            tdClass: "align-middle",
            formatter: value => {
              return this.$numeral(Math.abs(value)).format("$ 0,0");
            }
          },
          {
            key: 'status',
            label: this.lodash.startCase(this.$t('balancings.payment_status')),
            thStyle: {minWidth: '120px'},
            tdClass: 'align-middle',
            sortable: false,
            component: {
              props: ['item'],
              computed: {
                label() {
                  return this.lodash.upperFirst(this.$t(`balancings.payment_statuses.${this.item.state}`))
                },
                style(){
                  if (this.item.state === 'paid' || this.item.state === 'partial') {
                    return 'text-success'
                  } else if (this.item.state === 'in_payment') {
                    return 'text-warning'
                  }
                  return 'text-danger'
                },
              },
              template: `
                <div><span v-html="label" :class="style"></span></div>
              `
            }
          },
        ]
      };
    }
  },
  methods: {
    store(value) {
      return this.$axios.post(`/tickets/${this.$route.params.key}/trips`, value);
    },
    update(value) {
      return this.$axios.put(`/tickets/${this.$route.params.key}/trips/${this.getModelKey(value)}`, value);
    },
    delete(value) {
      return this.$axios.delete(`/tickets/${this.$route.params.key}/trips/${this.getModelKey(value)}`);
    },
    fetchModels(page = 1) {
      return this.$axios
        .get(`/balancing_transactions?sale_order[ticket_id__eq]=${this.$route.params.key}`, {
          params: {
            page: page,
            per_page: this.perPage,
            search: this.search,
            sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
            with: [
              "sale_order.trip",
              // 'sale_order.sale_items.trip',
              "customer",
              "profit_share",
              "manufacture",
              "balancing_payments.to_bank_account",
              "sale_order.sale_items.purchase_item.purchase_order.paymentables.payment"
            ].join(","),
            with_count: "balancing_payments",
            total_debt__gt: 0,
            ...this.filterParams
          }
        })
        .then(response => {
          const {
            data: { data, meta }
          } = response;
          this.models = data.map(datum => {
            return {
              ...datum
            };
          });
          this.page = Number(meta.current_page);
          this.perPage = Number(meta.per_page);
          this.from = Number(meta.from);
          this.total = Number(meta.total);

          this.stats = [];

          return response;
        })
        .catch(error => {
          this.failedAlert(error);
          return null;
        });
    }
  }
};
</script>
